import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
const API = '';
const tok = () => localStorage.getItem('nexus_token') || localStorage.getItem('vgo_token') || '';
const hdr = () => ({ 'Content-Type':'application/json', Authorization:`Bearer ${tok()}` });
const SECTIONS = ['Profile','Identity','Biometric','Skills','Experience','Education','Certifications','Privacy','Resume'];
const ID_TYPES = [['passport','Passport'],['aadhaar','Aadhaar'],['pan','PAN Card'],['driving','Driving License'],['voter','Voter ID'],['national','National ID'],['other','Other Govt ID']];
const inputStyle = { width:'100%', padding:'10px 12px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, fontSize:13, outline:'none', boxSizing:'border-box', color:'#0f172a', fontFamily:'inherit' };
const labelStyle = { fontSize:11, color:'#64748b', fontWeight:600, marginBottom:4, display:'block' };

function StatusBadge({ status }) {
  const cfg = {
    draft:    {bg:'#f1f5f9', color:'#64748b', label:'📝 Draft'},
    pending:  {bg:'#fef3c7', color:'#d97706', label:'⏳ Pending Verification'},
    verified: {bg:'#dcfce7', color:'#16a34a', label:'✅ Verified & Locked'},
    rejected: {bg:'#fee2e2', color:'#dc2626', label:'❌ Rejected'},
  }[status||'draft']||{bg:'#f1f5f9',color:'#64748b',label:'📝 Draft'};
  return <span style={{fontSize:10,fontWeight:700,padding:'3px 8px',borderRadius:10,background:cfg.bg,color:cfg.color}}>{cfg.label}</span>;
}

function UploadBtn({ onUploaded, label='📎 Attach Document' }) {
  const [uploading, setUploading] = useState(false);
  return (
    <label style={{display:'inline-flex',alignItems:'center',gap:6,padding:'6px 12px',
      background:'#eff6ff',borderRadius:8,cursor:'pointer',fontSize:11,fontWeight:600,color:'#1a3cc8'}}>
      <input type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" style={{display:'none'}}
        onChange={async(e)=>{
          const file=e.target.files[0]; if(!file) return;
          if(file.size>10*1024*1024){alert('Max 10MB');return;}
          setUploading(true);
          try {
            const fd=new FormData(); fd.append('file',file);
            const r=await fetch(`${API}/api/backend/v1/uploads`,{
              method:'POST',headers:{Authorization:`Bearer ${tok()}`},body:fd});
            const d=await r.json();
            if(d.url) onUploaded(d.url, file.name);
          } catch(e){alert('Upload failed');}
          finally{setUploading(false);}
        }}/>
      {uploading?'⏳ Uploading...':label}
    </label>
  );
}

function VerifyRequestForm({ recordType, recordId, onSent }) {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({institution_name:'',institution_email:'',message:''});
  const [sending, setSending] = useState(false);
  if(!show) return (
    <button onClick={()=>setShow(true)} style={{fontSize:10,fontWeight:700,
      padding:'4px 10px',background:'#fef3c7',border:'none',borderRadius:8,
      color:'#d97706',cursor:'pointer'}}>
      🔑 Request Verification
    </button>
  );
  return (
    <div style={{background:'#fffbeb',borderRadius:10,padding:12,marginTop:8,border:'1px solid #fde68a'}}>
      <div style={{fontSize:11,fontWeight:700,color:'#d97706',marginBottom:8}}>Send to institution for verification</div>
      {[{k:'institution_name',p:'Institution/Company name',l:'Institution Name'},
        {k:'institution_email',p:'hr@company.com',l:'Official Email *'},
        {k:'message',p:'Optional message...',l:'Message'},
      ].map(f=>(
        <div key={f.k} style={{marginBottom:8}}>
          <label style={labelStyle}>{f.l}</label>
          {f.k==='message'?
            <textarea value={form[f.k]} onChange={e=>setForm(p=>({...p,[f.k]:e.target.value}))}
              placeholder={f.p} style={{...inputStyle,height:60,resize:'none'}}/>:
            <input value={form[f.k]} onChange={e=>setForm(p=>({...p,[f.k]:e.target.value}))}
              placeholder={f.p} style={inputStyle}/>}
        </div>
      ))}
      <div style={{display:'flex',gap:8}}>
        <button onClick={async()=>{
          if(!form.institution_email){alert('Email required');return;}
          setSending(true);
          const r=await fetch(`${API}/api/backend/v1/gap/verify-request`,{
            method:'POST',headers:hdr(),
            body:JSON.stringify({record_type:recordType,record_id:recordId,...form})});
          const d=await r.json();
          if(d.success){toast.success('Verification request sent!');onSent();setShow(false);}
          setSending(false);
        }} style={{flex:1,padding:'8px',background:'#d97706',border:'none',
          borderRadius:8,color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
          {sending?'Sending...':'Send Request'}
        </button>
        <button onClick={()=>setShow(false)} style={{padding:'8px 12px',background:'#f1f5f9',
          border:'none',borderRadius:8,color:'#64748b',fontSize:11,cursor:'pointer'}}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default function GAPEditScreen() {
  const nav = useNavigate();
  const [section, setSection] = useState(0);
  const [certs, setCerts] = useState([]);
  const [certForm, setCertForm] = useState({title:'',issuer:'',issued_year:'',expiry_year:'',cert_id:'',cert_url:''});
  const [visibility, setVisibility] = useState({
    identity:'private',contact:'private',address:'private',
    skills:'public',education:'public',experience:'public',
    certifications:'public',languages:'public',portfolio:'public'
  });
  const [visSaved, setVisSaved] = useState(false);
  const [resumes, setResumes] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [profile, setProfile] = useState({
    full_name:'',display_name:'',dob:'',gender:'',nationality:'',
    current_city:'',current_country:'',address_declared:'',bio:'',
    profile_photo:'',id_type:'',id_partial:'',id_doc_url:'',
    face_url:'',voice_url:'',
    skills:[],languages:[],portfolio_links:[],
    is_available:false,is_public:true,
  });
  const [experience, setExperience]   = useState([]);
  const [education, setEducation]     = useState([]);
  const [skillInput, setSkillInput]   = useState('');
  const [langInput, setLangInput]     = useState('');
  const [portInput, setPortInput]     = useState('');
  const [saving, setSaving]           = useState(false);
  const [expForm, setExpForm] = useState({company:'',role:'',location:'',start_date:'',end_date:'',description:'',is_current:false});
  const [eduForm, setEduForm] = useState({institution:'',degree:'',field:'',start_year:'',end_year:'',is_current:false});

  useEffect(()=>{
    fetch(`${API}/api/backend/v1/gap/profile/me`,{headers:hdr()})
      .then(r=>r.json()).then(d=>{
        if(d.user_id) setProfile(p=>({...p,...d,
          skills:d.skills||[],languages:d.languages||[],portfolio_links:d.portfolio_links||[]}));
      }).catch(()=>{});
    fetch(`${API}/api/backend/v1/gap/profile/me/experience`,{headers:hdr()})
      .then(r=>r.json()).then(d=>setExperience(d.experience||[])).catch(()=>{});
    fetch(`${API}/api/backend/v1/gap/profile/me/education`,{headers:hdr()})
      .then(r=>r.json()).then(d=>setEducation(d.education||[])).catch(()=>{});
    fetch(`${API}/api/backend/v1/gap/certifications`,{headers:hdr()})
      .then(r=>r.json()).then(d=>setCerts(d.certifications||[])).catch(()=>{});
    fetch(`${API}/api/backend/v1/gap/resumes`,{headers:hdr()})
      .then(r=>r.json()).then(d=>setResumes(d.resumes||[])).catch(()=>{});
    fetch(`${API}/api/backend/v1/gap/visibility`,{headers:hdr()})
      .then(r=>r.json()).then(d=>{ if(d.visibility) setVisibility(d.visibility); }).catch(()=>{});
  },[]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await fetch(`${API}/api/backend/v1/gap/profile`,{method:'POST',headers:hdr(),body:JSON.stringify(profile)});
      toast.success('Profile saved!');
    } catch(e){ toast.error('Save failed'); }
    setSaving(false);
  };

  const addSkill = () => {
    if(skillInput.trim()&&profile.skills.length<20){
      setProfile(p=>({...p,skills:[...p.skills,skillInput.trim()]}));
      setSkillInput('');
    }
  };
  const addLang = () => {
    if(langInput.trim()&&profile.languages.length<10){
      setProfile(p=>({...p,languages:[...p.languages,langInput.trim()]}));
      setLangInput('');
    }
  };
  const addPort = () => {
    if(portInput.trim()){
      setProfile(p=>({...p,portfolio_links:[...p.portfolio_links,portInput.trim()]}));
      setPortInput('');
    }
  };

  const addExperience = async () => {
    if(!expForm.company||!expForm.role){alert('Company and role required');return;}
    const r=await fetch(`${API}/api/backend/v1/gap/experience`,{method:'POST',headers:hdr(),body:JSON.stringify(expForm)});
    const d=await r.json();
    if(d.success){setExperience(p=>[{id:d.id,...expForm,status:'draft'},...p]);setExpForm({company:'',role:'',location:'',start_date:'',end_date:'',description:'',is_current:false});}
  };
  const addEducation = async () => {
    if(!eduForm.institution||!eduForm.degree){alert('Institution and degree required');return;}
    const r=await fetch(`${API}/api/backend/v1/gap/education`,{method:'POST',headers:hdr(),body:JSON.stringify(eduForm)});
    const d=await r.json();
    if(d.success){setEducation(p=>[{id:d.id,...eduForm,status:'draft'},...p]);setEduForm({institution:'',degree:'',field:'',start_year:'',end_year:'',is_current:false});}
  };

  return (
    <div style={{maxWidth:430,margin:'0 auto',background:'#f8fafc',minHeight:'100vh',paddingBottom:100}}>
      {/* Header */}
      <div style={{background:'linear-gradient(135deg,#1a3cc8,#2d4fd6)',padding:'52px 16px 16px',position:'sticky',top:0,zIndex:100}}>
        <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
          <button onClick={()=>nav(-1)} style={{background:'rgba(255,255,255,0.15)',border:'none',borderRadius:10,width:36,height:36,color:'#fff',fontSize:18,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>‹</button>
          <div style={{fontSize:18,fontWeight:800,color:'#fff'}}>Edit GAP Profile</div>
        </div>
        <div style={{display:'flex',gap:4,overflowX:'auto',scrollbarWidth:'none'}}>
          {SECTIONS.map((s,i)=>(
            <button key={i} onClick={()=>setSection(i)} style={{flexShrink:0,padding:'5px 12px',borderRadius:16,border:'none',cursor:'pointer',fontSize:11,fontWeight:700,
              background:section===i?'#fff':'rgba(255,255,255,0.15)',color:section===i?'#1a3cc8':'#fff'}}>{s}</button>
          ))}
        </div>
      </div>

      <div style={{padding:16}}>

        {/* ── PROFILE ── */}
        {section===0 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              {[
                {k:'full_name',     l:'Full Name *',       p:'Your legal full name'},
                {k:'display_name',  l:'Display Name',      p:'Name shown publicly'},
                {k:'dob',           l:'Date of Birth',     p:'',t:'date'},
                {k:'nationality',   l:'Nationality',       p:'e.g. Indian'},
                {k:'current_city',  l:'Current City',      p:'e.g. Hyderabad'},
                {k:'current_country',l:'Country',          p:'e.g. India'},
                {k:'address_declared',l:'Address',         p:'Your current address'},
              ].map(f=>(
                <div key={f.k} style={{marginBottom:12}}>
                  <label style={labelStyle}>{f.l}</label>
                  <input type={f.t||'text'} value={profile[f.k]||''} onChange={e=>setProfile(p=>({...p,[f.k]:e.target.value}))} placeholder={f.p} style={inputStyle}/>
                </div>
              ))}
              <div style={{marginBottom:12}}>
                <label style={labelStyle}>Gender</label>
                <select value={profile.gender||''} onChange={e=>setProfile(p=>({...p,gender:e.target.value}))} style={inputStyle}>
                  <option value=''>Select</option>
                  {['Male','Female','Non-binary','Prefer not to say'].map(g=><option key={g} value={g.toLowerCase()}>{g}</option>)}
                </select>
              </div>
              <div style={{marginBottom:12}}>
                <label style={labelStyle}>Bio</label>
                <textarea value={profile.bio||''} onChange={e=>setProfile(p=>({...p,bio:e.target.value}))} placeholder="Brief professional summary..." style={{...inputStyle,height:80,resize:'none'}}/>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
                <input type="checkbox" checked={profile.is_available||false} onChange={e=>setProfile(p=>({...p,is_available:e.target.checked}))} id="avail"/>
                <label htmlFor="avail" style={{fontSize:12,color:'#334155'}}>Available for work / opportunities</label>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16}}>
                <input type="checkbox" checked={profile.is_public||false} onChange={e=>setProfile(p=>({...p,is_public:e.target.checked}))} id="pub"/>
                <label htmlFor="pub" style={{fontSize:12,color:'#334155'}}>Public profile (visible in GAP browse)</label>
              </div>
              <button onClick={saveProfile} disabled={saving} style={{width:'100%',padding:12,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>
                {saving?'Saving...':'Save Profile'}
              </button>
            </div>
          </div>
        )}

        {/* ── IDENTITY ── */}
        {section===1 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:4}}>🪪 Government ID</div>
              <div style={{fontSize:11,color:'#64748b',marginBottom:14}}>
                Your ID details are encrypted and stored securely. Only you control who sees them.
              </div>
              <div style={{marginBottom:12}}>
                <label style={labelStyle}>ID Type</label>
                <select value={profile.id_type||''} onChange={e=>setProfile(p=>({...p,id_type:e.target.value}))} style={inputStyle}>
                  <option value=''>Select ID type</option>
                  {ID_TYPES.map(([v,l])=><option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div style={{marginBottom:14}}>
                <label style={labelStyle}>Last 4 digits / partial ID</label>
                <input value={profile.id_partial||''} onChange={e=>setProfile(p=>({...p,id_partial:e.target.value}))} placeholder="e.g. XXXX-1234" style={inputStyle}/>
                <div style={{fontSize:10,color:'#94a3b8',marginTop:4}}>Never store full ID number here</div>
              </div>
              <div style={{marginBottom:14}}>
                <label style={labelStyle}>Upload ID Document (encrypted)</label>
                {profile.id_doc_url ? (
                  <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',
                    background:'#f0fdf4',borderRadius:8,border:'1px solid #bbf7d0'}}>
                    <span style={{fontSize:18}}>🔒</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:600,color:'#16a34a'}}>Document uploaded</div>
                      <div style={{fontSize:10,color:'#94a3b8'}}>Encrypted & secured</div>
                    </div>
                    <button onClick={()=>setProfile(p=>({...p,id_doc_url:''}))}
                      style={{padding:'4px 8px',background:'#fee2e2',border:'none',borderRadius:6,color:'#dc2626',fontSize:10,cursor:'pointer'}}>Remove</button>
                  </div>
                ) : (
                  <UploadBtn label="🔒 Upload ID (encrypted)" onUploaded={async(url)=>{
                    setProfile(p=>({...p,id_doc_url:url}));
                    await fetch(`${API}/api/backend/v1/gap/identity-doc`,{
                      method:'POST',headers:hdr(),body:JSON.stringify({id_doc_url:url})});
                    toast.success('ID document saved securely');
                  }}/>
                )}
              </div>
              <button onClick={saveProfile} style={{width:'100%',padding:12,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Save Identity</button>
            </div>
          </div>
        )}

        {/* ── BIOMETRIC ── */}
        {section===2 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:4}}>📸 Face Photo</div>
              <div style={{fontSize:11,color:'#64748b',marginBottom:14}}>
                Upload a clear face photo to prove you are a real person. Stored encrypted.
              </div>
              {profile.face_url ? (
                <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:14}}>
                  <img src={profile.face_url} alt="face" style={{width:80,height:80,borderRadius:12,objectFit:'cover',border:'2px solid #1a3cc8'}}/>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:'#16a34a'}}>✅ Face photo uploaded</div>
                    <button onClick={()=>setProfile(p=>({...p,face_url:''}))}
                      style={{marginTop:6,padding:'4px 10px',background:'#fee2e2',border:'none',borderRadius:6,color:'#dc2626',fontSize:11,cursor:'pointer'}}>Remove</button>
                  </div>
                </div>
              ) : (
                <UploadBtn label="📸 Upload Face Photo" onUploaded={(url)=>setProfile(p=>({...p,face_url:url}))}/>
              )}
            </div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:4}}>🎤 Voice Recording</div>
              <div style={{fontSize:11,color:'#64748b',marginBottom:14}}>
                Record yourself saying: "I am [your name] and this is my genuine VGO profile."
              </div>
              {profile.voice_url ? (
                <div style={{marginBottom:14}}>
                  <audio controls src={profile.voice_url} style={{width:'100%',marginBottom:8}}/>
                  <button onClick={()=>setProfile(p=>({...p,voice_url:''}))}
                    style={{padding:'4px 10px',background:'#fee2e2',border:'none',borderRadius:6,color:'#dc2626',fontSize:11,cursor:'pointer'}}>Remove</button>
                </div>
              ) : (
                <UploadBtn label="🎤 Upload Voice Recording" onUploaded={(url)=>setProfile(p=>({...p,voice_url:url}))}/>
              )}
            </div>
            {(profile.face_url||profile.voice_url) && (
              <button onClick={async()=>{
                const r=await fetch(`${API}/api/backend/v1/gap/biometric`,{
                  method:'POST',headers:hdr(),
                  body:JSON.stringify({face_url:profile.face_url,voice_url:profile.voice_url})});
                const d=await r.json();
                if(d.success) toast.success('Biometric saved!');
              }} style={{width:'100%',padding:12,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>
                Save Biometric
              </button>
            )}
            <div style={{background:'#eff6ff',borderRadius:12,padding:12,marginTop:12}}>
              <div style={{fontSize:11,fontWeight:700,color:'#1a3cc8',marginBottom:4}}>🔒 Privacy Note</div>
              <div style={{fontSize:11,color:'#3b5bdb',lineHeight:1.6}}>
                Your biometric data is encrypted and stored securely. VGO cannot access it without your permission. It is used only to verify you are a real person.
              </div>
            </div>
          </div>
        )}

        {/* ── SKILLS ── */}
        {section===3 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:10}}>Skills ({profile.skills.length}/20)</div>
              <div style={{display:'flex',gap:6,marginBottom:10}}>
                <input value={skillInput} onChange={e=>setSkillInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),addSkill())}
                  placeholder="e.g. React, Python, Marketing" style={{...inputStyle,flex:1}}/>
                <button onClick={addSkill} style={{background:'#1a3cc8',border:'none',borderRadius:10,padding:'10px 14px',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Add</button>
              </div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16}}>
                {profile.skills.map((sk,i)=>(
                  <div key={i} onClick={()=>setProfile(p=>({...p,skills:p.skills.filter((_,j)=>j!==i)}))}
                    style={{padding:'5px 10px',background:'#eff6ff',borderRadius:20,fontSize:12,fontWeight:600,color:'#1a3cc8',cursor:'pointer'}}>
                    {sk} ×
                  </div>
                ))}
              </div>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:8}}>Languages</div>
              <div style={{display:'flex',gap:6,marginBottom:10}}>
                <input value={langInput} onChange={e=>setLangInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),addLang())}
                  placeholder="e.g. English, Hindi" style={{...inputStyle,flex:1}}/>
                <button onClick={addLang} style={{background:'#1a3cc8',border:'none',borderRadius:10,padding:'10px 14px',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Add</button>
              </div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16}}>
                {profile.languages.map((l,i)=>(
                  <div key={i} onClick={()=>setProfile(p=>({...p,languages:p.languages.filter((_,j)=>j!==i)}))}
                    style={{padding:'5px 10px',background:'#f0fdf4',borderRadius:20,fontSize:12,fontWeight:600,color:'#16a34a',cursor:'pointer'}}>
                    {l} ×
                  </div>
                ))}
              </div>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:8}}>Portfolio Links</div>
              <div style={{display:'flex',gap:6,marginBottom:10}}>
                <input value={portInput} onChange={e=>setPortInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),addPort())}
                  placeholder="https://github.com/username" style={{...inputStyle,flex:1}}/>
                <button onClick={addPort} style={{background:'#1a3cc8',border:'none',borderRadius:10,padding:'10px 14px',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer'}}>Add</button>
              </div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16}}>
                {profile.portfolio_links.map((l,i)=>(
                  <div key={i} onClick={()=>setProfile(p=>({...p,portfolio_links:p.portfolio_links.filter((_,j)=>j!==i)}))}
                    style={{padding:'5px 10px',background:'#fff7ed',borderRadius:20,fontSize:11,fontWeight:600,color:'#ea580c',cursor:'pointer',wordBreak:'break-all'}}>
                    {l} ×
                  </div>
                ))}
              </div>
              <button onClick={saveProfile} style={{width:'100%',padding:12,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Save Skills</button>
            </div>
          </div>
        )}

        {/* ── EXPERIENCE ── */}
        {section===4 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:12}}>+ Add Experience</div>
              {[{k:'company',l:'Company *',p:'Company name'},{k:'role',l:'Job Title *',p:'e.g. Software Engineer'},
                {k:'location',l:'Location',p:'City, Country'},{k:'start_date',l:'Start Date',p:'',t:'date'},
                {k:'end_date',l:'End Date',p:'',t:'date'},{k:'description',l:'Description',p:'What did you do?'},
              ].map(f=>(
                <div key={f.k} style={{marginBottom:10}}>
                  <label style={labelStyle}>{f.l}</label>
                  {f.k==='description'?
                    <textarea value={expForm[f.k]} onChange={e=>setExpForm(p=>({...p,[f.k]:e.target.value}))} placeholder={f.p} style={{...inputStyle,height:60,resize:'none'}}/>:
                    <input type={f.t||'text'} value={expForm[f.k]} onChange={e=>setExpForm(p=>({...p,[f.k]:e.target.value}))} placeholder={f.p} style={inputStyle}/>}
                </div>
              ))}
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                <input type="checkbox" checked={expForm.is_current} onChange={e=>setExpForm(p=>({...p,is_current:e.target.checked}))} id="curr_exp"/>
                <label htmlFor="curr_exp" style={{fontSize:12,color:'#334155'}}>Currently working here</label>
              </div>
              <button onClick={addExperience} style={{width:'100%',padding:11,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Add Experience</button>
            </div>
            {experience.map((e,i)=>(
              <div key={e.id||i} style={{background:'#fff',borderRadius:12,padding:14,marginBottom:8,border:`1.5px solid ${e.is_locked?'#bbf7d0':e.status==='rejected'?'#fecaca':'#f1f5f9'}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:6}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>{e.role}</div>
                    <div style={{fontSize:11,color:'#64748b'}}>{e.company}{e.location?` · ${e.location}`:''}</div>
                    <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>
                      {e.start_date}{e.is_current?' — Present':e.end_date?` — ${e.end_date}`:''}
                    </div>
                    {e.verified_by && <div style={{fontSize:10,color:'#16a34a',marginTop:2}}>✅ Verified by {e.verified_by}</div>}
                    {e.rejection_reason && <div style={{fontSize:10,color:'#dc2626',marginTop:2}}>❌ Rejected: {e.rejection_reason}</div>}
                  </div>
                  <StatusBadge status={e.status}/>
                </div>
                {!e.is_locked && (
                  <div style={{display:'flex',gap:6,flexWrap:'wrap',marginTop:8}}>
                    <UploadBtn label="📎 Doc" onUploaded={async(url,name)=>{
                      await fetch(`${API}/api/backend/v1/gap/experience/${e.id}`,{
                        method:'PUT',headers:hdr(),body:JSON.stringify({doc_url:url})});
                      setExperience(p=>p.map(x=>x.id===e.id?{...x,doc_url:url}:x));
                      toast.success('Document attached');
                    }}/>
                    {e.status==='draft' && <VerifyRequestForm recordType="experience" recordId={e.id} onSent={()=>setExperience(p=>p.map(x=>x.id===e.id?{...x,status:'pending'}:x))}/>}
                    <button onClick={async()=>{
                      await fetch(`${API}/api/backend/v1/gap/experience/${e.id}`,{method:'DELETE',headers:hdr()});
                      setExperience(p=>p.filter(x=>x.id!==e.id));
                    }} style={{padding:'4px 10px',background:'#fee2e2',border:'none',borderRadius:8,color:'#dc2626',fontSize:10,cursor:'pointer'}}>Remove</button>
                  </div>
                )}
                {e.is_locked && <div style={{fontSize:10,color:'#16a34a',marginTop:6,fontWeight:700}}>🔒 Verified & Locked — cannot be edited</div>}
                {e.doc_url && <div style={{fontSize:10,color:'#1a3cc8',marginTop:4}}>📎 <a href={e.doc_url} target="_blank" rel="noreferrer" style={{color:'#1a3cc8'}}>View attached document</a></div>}
              </div>
            ))}
          </div>
        )}

        {/* ── EDUCATION ── */}
        {section===5 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:12}}>+ Add Education</div>
              {[{k:'institution',l:'Institution *',p:'University/School name'},{k:'degree',l:'Degree/Qualification *',p:'e.g. B.Tech'},
                {k:'field',l:'Field of Study',p:'e.g. Computer Science'},
                {k:'start_year',l:'Start Year',p:'2018',t:'number'},{k:'end_year',l:'End Year',p:'2022',t:'number'},
              ].map(f=>(
                <div key={f.k} style={{marginBottom:10}}>
                  <label style={labelStyle}>{f.l}</label>
                  <input type={f.t||'text'} value={eduForm[f.k]} onChange={e=>setEduForm(p=>({...p,[f.k]:e.target.value}))} placeholder={f.p} style={inputStyle}/>
                </div>
              ))}
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                <input type="checkbox" checked={eduForm.is_current} onChange={e=>setEduForm(p=>({...p,is_current:e.target.checked}))} id="curr_edu"/>
                <label htmlFor="curr_edu" style={{fontSize:12,color:'#334155'}}>Currently studying</label>
              </div>
              <button onClick={addEducation} style={{width:'100%',padding:11,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Add Education</button>
            </div>
            {education.map((e,i)=>(
              <div key={e.id||i} style={{background:'#fff',borderRadius:12,padding:14,marginBottom:8,border:`1.5px solid ${e.is_locked?'#bbf7d0':e.status==='rejected'?'#fecaca':'#f1f5f9'}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:6}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>{e.degree}{e.field?` in ${e.field}`:''}</div>
                    <div style={{fontSize:11,color:'#64748b'}}>{e.institution}</div>
                    <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{e.start_year}{e.is_current?' — Present':e.end_year?` — ${e.end_year}`:''}</div>
                    {e.verified_by && <div style={{fontSize:10,color:'#16a34a',marginTop:2}}>✅ Verified by {e.verified_by}</div>}
                    {e.rejection_reason && <div style={{fontSize:10,color:'#dc2626',marginTop:2}}>❌ Rejected: {e.rejection_reason}</div>}
                  </div>
                  <StatusBadge status={e.status}/>
                </div>
                {!e.is_locked && (
                  <div style={{display:'flex',gap:6,flexWrap:'wrap',marginTop:8}}>
                    <UploadBtn label="📎 Doc" onUploaded={async(url)=>{
                      setEducation(p=>p.map(x=>x.id===e.id?{...x,doc_url:url}:x));
                      toast.success('Document attached');
                    }}/>
                    {e.status==='draft' && <VerifyRequestForm recordType="education" recordId={e.id} onSent={()=>setEducation(p=>p.map(x=>x.id===e.id?{...x,status:'pending'}:x))}/>}
                    <button onClick={async()=>{
                      await fetch(`${API}/api/backend/v1/gap/education/${e.id}`,{method:'DELETE',headers:hdr()});
                      setEducation(p=>p.filter(x=>x.id!==e.id));
                    }} style={{padding:'4px 10px',background:'#fee2e2',border:'none',borderRadius:8,color:'#dc2626',fontSize:10,cursor:'pointer'}}>Remove</button>
                  </div>
                )}
                {e.is_locked && <div style={{fontSize:10,color:'#16a34a',marginTop:6,fontWeight:700}}>🔒 Verified & Locked — cannot be edited</div>}
                {e.doc_url && <div style={{fontSize:10,color:'#1a3cc8',marginTop:4}}>📎 <a href={e.doc_url} target="_blank" rel="noreferrer" style={{color:'#1a3cc8'}}>View document</a></div>}
              </div>
            ))}
          </div>
        )}

        {/* ── CERTIFICATIONS ── */}
        {section===6 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:12}}>🏆 Add Certification</div>
              {[
                {key:'title',    label:'Certification Title *', placeholder:'e.g. AWS Solutions Architect'},
                {key:'issuer',   label:'Issuing Organization *', placeholder:'e.g. Amazon Web Services'},
                {key:'issued_year', label:'Year Issued', placeholder:'2023', type:'number'},
                {key:'expiry_year', label:'Expiry Year', placeholder:'2026 (optional)', type:'number'},
                {key:'cert_id',  label:'Certificate ID',  placeholder:'Optional credential ID'},
                {key:'cert_url', label:'Certificate URL', placeholder:'https://verify.example.com/...'},
              ].map(f=>(
                <div key={f.key} style={{marginBottom:10}}>
                  <label style={labelStyle}>{f.label}</label>
                  <input type={f.type||'text'} value={certForm[f.key]} onChange={e=>setCertForm(p=>({...p,[f.key]:e.target.value}))} placeholder={f.placeholder} style={inputStyle}/>
                </div>
              ))}
              <button onClick={async()=>{
                if(!certForm.title||!certForm.issuer){alert('Title and issuer required');return;}
                const res=await fetch(`${API}/api/backend/v1/gap/certifications`,{method:'POST',headers:hdr(),body:JSON.stringify({...certForm,issued_year:certForm.issued_year?parseInt(certForm.issued_year):null,expiry_year:certForm.expiry_year?parseInt(certForm.expiry_year):null})});
                const d=await res.json();
                if(d.success){setCerts(p=>[{id:d.id,...certForm,status:'draft'},...p]);setCertForm({title:'',issuer:'',issued_year:'',expiry_year:'',cert_id:'',cert_url:''});}
              }} style={{width:'100%',padding:11,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>
                + Add Certification
              </button>
            </div>
            {certs.map((c,i)=>(
              <div key={c.id||i} style={{background:'#fff',borderRadius:12,padding:14,marginBottom:8,border:`1.5px solid ${c.is_locked?'#bbf7d0':c.status==='rejected'?'#fecaca':'#f1f5f9'}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:6}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>{c.title}</div>
                    <div style={{fontSize:11,color:'#64748b'}}>{c.issuer}</div>
                    {c.issued_year && <div style={{fontSize:11,color:'#94a3b8'}}>{c.issued_year}{c.expiry_year?` — ${c.expiry_year}`:''}</div>}
                    {c.verified_by && <div style={{fontSize:10,color:'#16a34a',marginTop:2}}>✅ Verified by {c.verified_by}</div>}
                    {c.rejection_reason && <div style={{fontSize:10,color:'#dc2626',marginTop:2}}>❌ {c.rejection_reason}</div>}
                  </div>
                  <StatusBadge status={c.status}/>
                </div>
                {!c.is_locked && (
                  <div style={{display:'flex',gap:6,flexWrap:'wrap',marginTop:8}}>
                    <UploadBtn label="📎 Doc" onUploaded={async(url)=>{
                      setCerts(p=>p.map(x=>x.id===c.id?{...x,doc_url:url}:x));
                      toast.success('Document attached');
                    }}/>
                    {c.status==='draft' && <VerifyRequestForm recordType="certification" recordId={c.id} onSent={()=>setCerts(p=>p.map(x=>x.id===c.id?{...x,status:'pending'}:x))}/>}
                    <button onClick={async()=>{
                      await fetch(`${API}/api/backend/v1/gap/certifications/${c.id}`,{method:'DELETE',headers:hdr()});
                      setCerts(p=>p.filter(x=>x.id!==c.id));
                    }} style={{padding:'4px 10px',background:'#fee2e2',border:'none',borderRadius:8,color:'#dc2626',fontSize:10,cursor:'pointer'}}>Remove</button>
                  </div>
                )}
                {c.is_locked && <div style={{fontSize:10,color:'#16a34a',marginTop:6,fontWeight:700}}>🔒 Verified & Locked — cannot be edited</div>}
              </div>
            ))}
          </div>
        )}

        {/* ── PRIVACY ── */}
        {section===7 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:4}}>🔒 Privacy Controls</div>
              <div style={{fontSize:11,color:'#64748b',marginBottom:16}}>Control who can see each section</div>
              {[
                {key:'identity',      label:'🪪 Identity & ID'},
                {key:'contact',       label:'📱 Contact Info'},
                {key:'address',       label:'📍 Address'},
                {key:'skills',        label:'💡 Skills'},
                {key:'education',     label:'🎓 Education'},
                {key:'experience',    label:'💼 Experience'},
                {key:'certifications',label:'🏆 Certifications'},
                {key:'languages',     label:'🌐 Languages'},
                {key:'portfolio',     label:'🔗 Portfolio'},
              ].map(f=>(
                <div key={f.key} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #f1f5f9'}}>
                  <div style={{flex:1,fontSize:13,fontWeight:600,color:'#1e293b'}}>{f.label}</div>
                  <select value={visibility[f.key]||'public'} onChange={e=>setVisibility(p=>({...p,[f.key]:e.target.value}))}
                    style={{padding:'6px 10px',borderRadius:8,border:'1px solid #e2e8f0',fontSize:12,fontWeight:600,background:'#f8fafc',cursor:'pointer'}}>
                    <option value="public">🌍 Public</option>
                    <option value="on_request">🔑 On Request</option>
                    <option value="private">🔒 Private</option>
                  </select>
                </div>
              ))}
              <button onClick={async()=>{
                const r=await fetch(`${API}/api/backend/v1/gap/visibility`,{method:'POST',headers:hdr(),body:JSON.stringify(visibility)});
                const d=await r.json();
                if(d.success){setVisSaved(true);setTimeout(()=>setVisSaved(false),2000);}
              }} style={{width:'100%',marginTop:16,padding:11,background:'#1a3cc8',border:'none',borderRadius:10,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>
                {visSaved?'✅ Saved!':'Save Privacy Settings'}
              </button>
            </div>
          </div>
        )}

        {/* ── RESUME ── */}
        {section===8 && (
          <div>
            <div style={{background:'#fff',borderRadius:14,padding:16,marginBottom:12,border:'1px solid #f1f5f9'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1e293b',marginBottom:4}}>📄 Resume / CV</div>
              <div style={{fontSize:11,color:'#64748b',marginBottom:14}}>Upload PDF, DOC, DOCX — max 10MB</div>
              <label style={{display:'block',border:'2px dashed #c7d2fe',borderRadius:12,padding:'24px',textAlign:'center',cursor:'pointer',background:'#f8faff'}}>
                <input type="file" accept=".pdf,.doc,.docx" style={{display:'none'}}
                  onChange={async(e)=>{
                    const file=e.target.files[0]; if(!file) return;
                    if(file.size>10*1024*1024){alert('Max 10MB');return;}
                    setUploading(true);
                    try {
                      const fd=new FormData(); fd.append('file',file);
                      const up=await fetch(`${API}/api/backend/v1/uploads`,{method:'POST',headers:{Authorization:`Bearer ${tok()}`},body:fd});
                      const ud=await up.json();
                      if(ud.url){
                        const res=await fetch(`${API}/api/backend/v1/gap/resumes`,{method:'POST',headers:hdr(),body:JSON.stringify({file_url:ud.url,file_name:file.name,file_size:file.size,is_primary:resumes.length===0})});
                        const rd=await res.json();
                        if(rd.success){setResumes(p=>[{id:rd.id,file_url:ud.url,file_name:file.name,file_size:file.size,is_primary:p.length===0},...p]);toast.success('Resume uploaded!');}
                      }
                    } catch(e){alert('Upload failed');}
                    finally{setUploading(false);}
                  }}/>
                {uploading?<div style={{fontSize:13,color:'#6366f1'}}>⏳ Uploading...</div>:(
                  <><div style={{fontSize:28,marginBottom:6}}>📤</div>
                  <div style={{fontSize:13,fontWeight:700,color:'#4f46e5'}}>Tap to upload resume</div>
                  <div style={{fontSize:11,color:'#94a3b8',marginTop:4}}>PDF, DOC, DOCX up to 10MB</div></>
                )}
              </label>
            </div>
            {resumes.map((r,i)=>(
              <div key={r.id||i} style={{background:'#fff',borderRadius:12,padding:14,marginBottom:8,border:'1px solid #f1f5f9',display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:40,height:40,borderRadius:10,background:'#eff6ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>📄</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.file_name}</div>
                  <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>
                    {r.file_size?`${(r.file_size/1024).toFixed(0)}KB · `:''}
                    {r.is_primary&&<span style={{color:'#10b981',fontWeight:700}}>✅ Primary</span>}
                  </div>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <a href={r.file_url} target="_blank" rel="noreferrer" style={{padding:'5px 10px',background:'#eff6ff',borderRadius:8,color:'#1a3cc8',fontSize:11,fontWeight:600,textDecoration:'none'}}>View</a>
                  {!r.is_primary&&<button onClick={async()=>{
                    await fetch(`${API}/api/backend/v1/gap/resumes`,{method:'POST',headers:hdr(),body:JSON.stringify({...r,is_primary:true})});
                    setResumes(p=>p.map(x=>({...x,is_primary:x.id===r.id})));
                  }} style={{padding:'5px 10px',background:'#dcfce7',border:'none',borderRadius:8,color:'#16a34a',fontSize:11,fontWeight:600,cursor:'pointer'}}>Primary</button>}
                  <button onClick={async()=>{
                    await fetch(`${API}/api/backend/v1/gap/resumes/${r.id}`,{method:'DELETE',headers:hdr()});
                    setResumes(p=>p.filter(x=>x.id!==r.id));
                  }} style={{padding:'5px 10px',background:'#fee2e2',border:'none',borderRadius:8,color:'#dc2626',fontSize:11,fontWeight:600,cursor:'pointer'}}>✕</button>
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}
